import { render, staticRenderFns } from "./ActiveTable.vue?vue&type=template&id=1f52d2c2"
import script from "./ActiveTable.vue?vue&type=script&lang=js"
export * from "./ActiveTable.vue?vue&type=script&lang=js"
import style0 from "./ActiveTable.vue?vue&type=style&index=0&id=1f52d2c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports